import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { Case } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetUserCases = (userId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Case[]>(
    [QueryEntity.Cases, { userId }],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/case`, fetchConfigGET);
      if (!res.ok) {
        throw new Error('Failed to fetch user cases');
      }
      return await res.json();
    },
    {
      refetchOnWindowFocus: false,
    },
  );
};
